import { createColumnHelper } from "@tanstack/react-table";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { Can, ReactTable } from "components";
import { EditChecklistsButton } from "modules/PendingChecklistsDashboard/components";
import { PinTypeIconAndMessage } from "modules/PendingChecklistsDashboard/components/PinChecklists/components/PinChecklistsTable/components";
import "modules/PendingChecklistsDashboard/components/PinChecklists/components/PinChecklistsTable/PinChecklistsTable.scss";

import type { PIN_TYPES } from "models";
import type { PinPendingChecklistsByPinType } from "modules/PendingChecklistsDashboard/components/PinChecklists/hooks";

type PinChecklistTableProps = {
  handleOpenPinPendingChecklist: (pinType: PIN_TYPES) => void;
  pinPendingChecklistsGroupedByPinType?: PinPendingChecklistsByPinType[];
};

const columnHelper = createColumnHelper<PinPendingChecklistsByPinType>();

export const PinChecklistsTable = ({ pinPendingChecklistsGroupedByPinType, handleOpenPinPendingChecklist }: PinChecklistTableProps) => {
  const { t } = useTranslation();

  const columns = useMemo(
    () => [
      columnHelper.accessor(row => row, {
        id: "pin_type",
        header: () => <span>{t("v8_pin_type", "Pin Type")}</span>,
        size: 230,
        cell: ({
          row: {
            original: { pin_type }
          }
        }) => <PinTypeIconAndMessage pinType={pin_type} t={t} />
      }),
      columnHelper.accessor(row => row, {
        id: "checklist_count",
        header: () => <span>{t("v8_checklists", "Checklists")}</span>,
        size: 800,
        cell: ({
          row: {
            original: { checklists }
          }
        }) => <span>{checklists.length}</span>
      }),
      columnHelper.accessor(row => row, {
        id: "actions",
        size: 50,
        header: () => "",
        cell: ({
          row: {
            original: { pin_type }
          }
        }) => (
          <Can I={["create", "reorder", "delete"]} the="pin-pending-checklist">
            <EditChecklistsButton onClick={() => handleOpenPinPendingChecklist(pin_type)} />
          </Can>
        )
      })
    ],
    [t, handleOpenPinPendingChecklist]
  );

  return (
    <div className="PinChecklistsTable">
      <ReactTable columns={columns} data={pinPendingChecklistsGroupedByPinType} />
    </div>
  );
};
